import { useAppStore } from '@halo/chat-sdk-react';
import type { SessionProps } from '../types';
import { SessionEditorContext } from '../../session-parts';
import { SessionSingleContent } from './session-single-content';

export interface SessionSingleProps extends SessionProps {}

export function SessionSingle({ sessionStoreInstance, ...props }: SessionSingleProps) {
  const mediaStores = useAppStore((store) => store.mediaStores);

  const sessionId = useMemo(() => {
    return sessionStoreInstance.getState().session!.chat_id;
  }, [sessionStoreInstance]);

  const mediaStoreInstance = useMemo(() => {
    return mediaStores[sessionId];
  }, [mediaStores, sessionId]);

  return (
    <SessionEditorContext>
      <SessionSingleContent
        {...props}
        sessionStoreInstance={sessionStoreInstance}
        mediaStoreInstance={mediaStoreInstance}
      ></SessionSingleContent>
    </SessionEditorContext>
  );
}
